import { RootState } from '../../../types/root-state';
import { InstoreServiceInitialState } from './slice';

const selectDomain = (state: RootState) => state.spl.instoreService || InstoreServiceInitialState;

export const selectServices = (state: RootState) => selectDomain(state).services;
export const selectServiceNetwork = (state: RootState) => selectDomain(state).serviceNetwork;
